<template>
  <div>
    <section>
      <div class="inner row5">
        <article class="loginInner">
          <h1>비밀번호 재설정</h1>
          <div class="aRow5">
            <p>
              비밀번호를 입력해주세요.
            </p>
            <p>
              로그인 후 비밀번호를 바로 변경해주시기 바랍니다.
            </p>
          </div>

          <ValidationObserver v-slot="{ handleSubmit }">
            <form class="aRow5" @submit.prevent="handleSubmit(onClickResetPassword)">
              <ValidationProvider class="inputBox" name="비밀번호" rules="required|pw" vid="비밀번호" v-slot="{errors}">
                  <label>비밀번호(특수문자 포함, 8자리 이상)</label>
                  <input type="password" v-model="password" maxlength="16" autocomplete="new-password">
                  <span class="notValidationTxt positionFix">{{errors[0]}}</span>
              </ValidationProvider>
              <ValidationProvider class="inputBox" name="비밀번호 재확인" rules="required|confirmed:@비밀번호" vid="비밀번호 재확인" v-slot="{errors}">
                  <label>비밀번호 확인(한번 더 입력해주세요.)</label>
                  <input type="password" v-model="confirmedPassword" maxlength="16">
                  <span class="notValidationTxt positionFix">{{errors[0]}}</span>
              </ValidationProvider>

              <div class="inputBtnBox">
                <input type="submit" value="확인">
                <router-link to="/auth" replace><span class="joinTxt nomargin"><strong>로그인으로 돌아가기</strong></span></router-link>
              </div>
            </form>
          </ValidationObserver>
        </article>
      </div>
    </section> 
  </div>   
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import * as validationUtil from '@/utils/validationUtil'
import { mapActions } from 'vuex'

export default {
  name: 'PWReset',
  components: {
    ValidationObserver, 
    ValidationProvider
  },
  data(){
    return{
      password: '',
      confirmedPassword: '',  // 비밀번호 재확인 값
    }
  },
  methods:{
    ...mapActions('auth',[
      'resetPassword'
    ]),
    onClickResetPassword(){
      const userIdx = this.$route.params.userIdx
      const phoneNumber = this.$route.params.phoneNumber
      const id = this.$route.params.id
      const password = this.password

      if(validationUtil.isEmpty(userIdx) || userIdx <= 0 ||
      validationUtil.isEmpty(phoneNumber) ||
      validationUtil.isEmpty(id)){
        this.$alert("알림", "사용자 정보를 알 수 없습니다.");
        return
      }

      this.resetPassword({
        userIdx: userIdx,
        phoneNumber: phoneNumber,
        id: id,
        password: password
      })
      .then(response => {
        var data = response.data
        if(data.RESULT == true){
          this.$alert('알림', '비밀번호가 변경되었습니다.', null, {
            'closed': ()=>{
              this.$router.replace({path: '/auth'})
            }
          })
        }
        else{
          this.$alert('알림', '비밀번호 재설정을 실패했습니다.')
        }
      })
      .catch(()=>{
        this.$alert('알림', '요청을 실패했습니다.')
      })
    }
  }
}
</script>

<style scoped>
  .loginInner > h1 {
    color: #9E1915;
  }
</style>